import React, { useState } from 'react'
import { UnlockedIcon } from '@instacart/ids-core'
import { Button, Confirm, Tooltip } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import LoadingDots from 'legacy/components/LoadingDots'
import { useDomainMessages } from 'domains/account-management/utils/domain/intl'
import { useDisableAccount } from 'domains/account-management/utils/useDisableAccount.hooks'
import { accountButtonStyle } from 'domains/account-management/components/accounts-list/components/list/ListAccountsGridList'

const StyledLoadingDots = styled.div({
  width: 44,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

interface Props {
  accountCanonicalId: string
  target: string
  refetchAccounts?: () => void
}

export const EnableAccountButton: React.FunctionComponent<Props> = ({
  accountCanonicalId,
  target,
  refetchAccounts,
  ...props
}) => {
  const { disableAccount, loading } = useDisableAccount({
    accountCanonicalId,
    showNotifications: true,
    disable: false,
    refetchAccounts,
  })

  const messages = useDomainMessages(
    {
      confirmButton: 'accountManagementDomain.enableAccount.confirm.confirmLabel',
      cancelButton: 'accountManagementDomain.enableAccount.confirm.cancelLabel',
      confirmContent: 'accountManagementDomain.enableAccount.confirm.content',
      reactivateTitle: 'accountManagementDomain.enableAccount.reactivateTitle',
    },
    { target }
  )

  const [showModal, setShowModal] = useState(false)

  const modalOpen = () => setShowModal(true)
  const modalClose = () => setShowModal(false)

  return (
    <React.Fragment>
      {loading ? (
        <StyledLoadingDots data-testid={props['data-testid'] + '-loading'}>
          <LoadingDots height={5} />
        </StyledLoadingDots>
      ) : (
        <Tooltip
          placement="bottom"
          target={
            <Button
              variant={'tertiary'}
              compact={true}
              onClick={modalOpen}
              data-testid={props['data-testid']}
              css={accountButtonStyle}
            >
              <UnlockedIcon size={16} color="systemGrayscale70" />
            </Button>
          }
        >
          {messages.reactivateTitle}
        </Tooltip>
      )}

      <Confirm
        data-testid="enable-account"
        bodyContent={messages.confirmContent}
        isOpen={showModal}
        onRequestClose={modalClose}
        onConfirm={disableAccount}
        confirmLabel={messages.confirmButton}
        cancelLabel={messages.cancelButton}
      />
    </React.Fragment>
  )
}
